export const namespace = 'canalplus.block.maverick.tiles';
export { default as Component } from './components/Tiles';
export { default as propsFormatter } from './propsFormatter';
